import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/helpers/axios";
import type { ApiResponse } from "@/helpers/axios";
import type { ApiDevice } from "../_types/devices.types";

export const useDeviceQuery = (deviceId: string | null) => {
  return useQuery({
    queryKey: ["device", deviceId],
    queryFn: async () => {
      const response = await axiosInstance.get<ApiResponse<ApiDevice>>(`/v2/devices/${deviceId}`);
      return response.data.data ?? null;
    },
    enabled: Boolean(deviceId),
    refetchInterval: 25_000,
  });
};
